export const defaultFunnelManager= [
    {
        "familyId": "3",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "14",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "53",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "54",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "55",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "56",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "57",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "63",
        "embededFamilies": [
            "30"
        ],
        "expanded": false
    },
    {
        "familyId": "8",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "12",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "64",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "5",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "11",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "13",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "40",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "69",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "78",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "75",
        "embededFamilies": [],
        "expanded": false
    },
    {
        "familyId": "4",
        "embededFamilies": [],
        "expanded": false
    }
];